import UIAssetFilterGroupList from "../../components/uiassetfilters/UIAssetFilterGroupList";

const UIAssetFilterGroups: React.FC<{}> = () => {
  return (
    <>
        <div>
            <UIAssetFilterGroupList />    
        </div>     
    </>
  );
};

export default UIAssetFilterGroups;
